import { render, staticRenderFns } from "./points-match-list.vue?vue&type=template&id=1befdf00&scoped=true&"
import script from "./points-match-list.vue?vue&type=script&lang=js&"
export * from "./points-match-list.vue?vue&type=script&lang=js&"
import style0 from "./points-match-list.vue?vue&type=style&index=0&id=1befdf00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1befdf00",
  null
  
)

export default component.exports